import React, { useState, Fragment } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import { Mutation, compose } from "react-apollo";
import CircularProgress from "@material-ui/core/CircularProgress";
import gql from "graphql-tag";
import { format, parseISO } from "date-fns";
import { withNotification } from "../../../notification/context";

const MUTATION = gql`
  mutation deleteTask($id: ID!) {
    deleteTask(id: $id) {
      task {
        n
        deletedCount
      }
      stats {
        n
        deletedCount
      }
    }
  }
`;

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit
  }
});

const DeleteDialogContent = ({
  row,
  onClose,
  onSubmit,
  shouldBeOpen,
  ...props
}) => {
  if (!shouldBeOpen) {
    return null;
  }
  const parsedDate = parseISO(row.createdAt);
  const formatedDate = format(parsedDate, "dd/MM/yyyy hh:mm:ss aaaa");
  return (
    <Fragment>
      <DialogContent>
        <DialogContentText>
          ¿Está seguro que desea eliminar las estadisticas de la fecha{" "}
          {formatedDate} con descripción {row.description}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={onSubmit} color="secondary">
          Eliminar
        </Button>
      </DialogActions>
    </Fragment>
  );
};

const DeleteDialogResult = ({ data, onClose, shouldBeOpen }) => {
  if (!shouldBeOpen) {
    return null;
  }
  const { deleteTask } = data;
  return (
    <Fragment>
      <DialogContent>
        <DialogContentText>
          Datos eliminados correctamente. Tareas eliminadas:{" "}
          {deleteTask.task.deletedCount} Estadistícas eliminadas:{" "}
          {deleteTask.stats.deletedCount}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Fragment>
  );
};

const DeleteDialogLoading = ({ shouldBeOpen }) => {
  if (!shouldBeOpen) {
    return null;
  }
  return (
    <DialogContent>
      <Row center="xs">
        <Col xs>
          <CircularProgress size={60} />
        </Col>
      </Row>
    </DialogContent>
  );
};

const DeleteIndicator = ({
  classes,
  openNotification,
  query,
  variables,
  row
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={MUTATION}
      update={cache => {
        const { statsTaskByLayer } = cache.readQuery({
          query,
          variables
        });
        cache.writeQuery({
          query,
          variables,
          data: {
            statsTaskByLayer: statsTaskByLayer.filter(
              item => item.id !== row.id
            )
          }
        });
      }}
    >
      {(mutation, { called, loading, data }) => {
        const deleteUserFn = () => {
          mutation({ variables: { id: row.id } })
            .then(() => {
              openNotification("Estadísticas eliminadas correctamente.");
              handleClose();
            })
            .catch(() => {
              openNotification("Error eliminando las estadísticas");
              //handleClose();
            });
        };
        return (
          <Fragment>
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              className={classes.fab}
              onClick={handleClickOpen}
            >
              Eliminar
            </Button>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">
                Eliminar estadísticas
              </DialogTitle>
              <DeleteDialogContent
                shouldBeOpen={!called}
                row={row}
                onClose={handleClose}
                onSubmit={deleteUserFn}
              />
              <DeleteDialogLoading shouldBeOpen={loading && called} />
              <DeleteDialogResult
                data={data}
                shouldBeOpen={called && !loading}
                onClose={handleClose}
              />
            </Dialog>
          </Fragment>
        );
      }}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(DeleteIndicator);



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/button-delete.js